<template>
    <div :class="getClass">
        <!--
        <button v-if="showButton" type="button" @click="onButtonClick" class="btn btn_border btn_s">{{buttonText}}</button>
        <span v-else :class="getClass">{{buttonText}}</span>
        -->
        {{scheduleText}}
    </div>
</template>
<script>
import Base from './CMP_AIS_00005_COMP_BASE';

export default {
    name:'CMP_AIS_00005_C03',
    extends:Base,
    components:{},
    props:{},
    data(){
        return {
            //props : ['row','value','text'], 
        }
    },
    created(){},
    mounted(){},
    computed:{
        scheduleText(){
            if(this.row.scheduleStatus === 'Y') {
                return '사용';
            } else {
                return '미사용';
            }
        },
    },
    methods:{
        /*
        onButtonClick(){
            let parent = this.getComponent('ServiceRequestNewModal');
            switch(this.row.statusCode) {
                case 'B':
                    parent.items[this.row.__idx].statusCode = this.row.statusCode;
                    parent.onClickRowDel(this.row);
                    break;
                case 'D':
                    this.row.statusCode = 'E';
                    parent.items[this.row.__idx].statusCode = this.row.statusCode;
                    break;
                case 'E':
                    this.row.statusCode = 'D';
                    parent.items[this.row.__idx].statusCode = this.row.statusCode;
                    break;
                default:
                    return;
            }
        },
        */
    },
}
</script>